import React from "react";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { MdAddIcCall } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import ContactWithEmail from "./ContactWithEmail";

const Contact = () => {
  return (
    <div
      name="contact"
      className="bg-gradient-to-b from-gray-800 to-black w-full"
    >
      <div className="max-w-screen-lg mx-auto p-4 pt-10 flex flex-col justify-center w-full h-full text-white ">
        <div className="">
          <div className="flex flex-wrap">
            <div className="w-full shrink-0 grow-0 basis-auto lg:w-7/12">
              <div className="flex flex-wrap">
                <div className="mb-12 w-full shrink-0 grow-0 basis-auto lg:w-full ">
                  <div className="">
                    <p className="text-4xl font-bold border-b-4 border-gray-500 pb-2 inline">
                      Contact Us
                    </p>

                    <p
                      className="pt-5 text-4xl "
                      style={{
                        fontFamily: "font-family: Helvetica, Arial, sans-serif",
                      }}
                    >
                      Prepare to turn your ideas into reality ?
                    </p>
                    <br />
                    <p className="text-md text-neutral-500">
                      Thank you for visiting my profile! Whether you have a
                      questions, want to discuss a potential collaboration, or
                      just want to say hello, I'm here to help. Please feel free
                      to reach out me.
                    </p>
                  </div>
                </div>

                <div className="mb-12 w-full shrink-0 grow-0 basis-auto md:w-full md:px-3 lg:px-6">
                  <div className="align-start flex flex-col md:flex-row">
                    <div className="flex items-start mb-3 md:mb-0 md:mr-3">
                      <div className="inline-block rounded-md bg-teal-400-100 p-4 text-teal-700">
                        <span>
                          <MdEmail size={24} />
                        </span>
                      </div>
                      <div className="ml-3 grow">
                        <p className="font-bold">Email</p>
                        <p className="text-neutral-500">
                          rksraman.work@gmail.com
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start mt-3 md:mt-0 md:ml-3">
                      <div className="inline-block rounded-md bg-teal-400-100 p-4 text-teal-700">
                        <span>
                          <MdAddIcCall size={24} />
                        </span>
                      </div>
                      <div className="ml-3 grow">
                        <p className="font-bold">Phone </p>
                        <p className="text-neutral-500">+91 7351500899</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ContactWithEmail />
          </div>

          <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8 border-t border-teal-400">
            <div class="sm:flex sm:items-center sm:justify-between">
              <span class="text-sm text-white sm:text-center dark:text-white">
                © 2024{" "}
                <Link
                  to="https://www.linkedin.com/in/iramansharma73/"
                  class="hover:underline cursor-pointer"
                >
                  Raman Sharma{" "}
                </Link>
                . All Rights Reserved.
              </span>
              <div class="flex mt-4 sm:justify-center sm:mt-0">
                <div>
                  <Link
                    to="https://www.linkedin.com/in/iramansharma73/"
                    target="_blank"
                    class="text-teal-400 hover:text-teal-500 dark:hover:text-white cursor-pointer"
                  >
                    <span>
                      <FaLinkedinIn />
                    </span>
                    <span class="sr-only">Linkedin</span>
                  </Link>
                </div>
                <div>
                  <Link
                    to="/"
                    class="flex sm:justify-center sm:mt-0 ms-5 text-teal-400 hover:text-teal-500 dark:hover:text-white cursor-pointer"
                  >
                    <span>
                      <FaWhatsapp />
                    </span>
                    <span class="sr-only">Whatshapp</span>
                  </Link>
                </div>
                <Link
                  to="https://www.instagram.com/iramansharma73/"
                  target="_blank"
                  class="text-teal-400 hover:text-teal-500 dark:hover:text-teal-500 ms-5 cursor-pointer"
                >
                  <FaInstagram />
                  <span class="sr-only">Instagram</span>
                </Link>
                <Link
                  to="https://twitter.com/iramansharma73"
                  target="_blank"
                  class="text-teal-400 hover:text-teal-500 dark:hover:text-teal-500 cursor-pointer ms-5"
                >
                  <span>
                    <FaTwitter />
                  </span>
                  <span class="sr-only">Twitter</span>
                </Link>
                <Link
                  to="https://www.facebook.com/iramansharma73"
                  target="_blank"
                  class="text-teal-400 hover:text-teal-500 dark:hover:text-teal cursor-pointer ms-5"
                >
                  <span>
                    <FaFacebookF />
                  </span>
                  <span class="sr-only">Facebook</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
